export default __webpack_public_path__ + "static/media/Visual 2.b42e5d72.png";